import { Container } from '@playcanvas/pcui';
import { Mat4, Vec3 } from 'playcanvas';

import { Events } from '../events';
import { Scene } from '../scene';
import { Splat } from '../splat';

const mat = new Mat4();
const p = new Vec3();

class AnnotationTool {
    activate: () => void;
    deactivate: () => void;

    constructor(events: Events, scene: Scene, canvasContainer: Container) {
        let active = false;
        let splat: Splat = null;
        let clicked = false;

        // Track selected splat — same as measure tool
        events.on('selection.changed', (s: Splat) => {
            splat = s;
        });

        const isPrimary = (e: PointerEvent) => {
            return e.pointerType === 'mouse' ? e.button === 0 : e.isPrimary;
        };

        const pointerdown = (e: PointerEvent) => {
            if (isPrimary(e)) clicked = true;
        };

        const pointermove = () => {
            clicked = false;
        };

        const pointerup = async (e: PointerEvent) => {
            if (!clicked || !isPrimary(e)) return;
            clicked = false;

            const nx = e.offsetX / canvasContainer.dom.clientWidth;
            const ny = e.offsetY / canvasContainer.dom.clientHeight;

            try {
                const result = await scene.camera.intersect(nx, ny);
                if (result && result.position && splat) {
                    // Store hit point in splat LOCAL space — identical to measure tool
                    // This makes the annotation stick when splat is transformed
                    mat.invert(splat.worldTransform);
                    mat.transformPoint(result.position, p);

                    events.fire('annotation.placed', {
                        localPos:  { x: p.x, y: p.y, z: p.z },
                        worldPos:  { x: result.position.x, y: result.position.y, z: result.position.z },
                        splatUid:  splat.uid,
                        screenX:   e.offsetX,
                        screenY:   e.offsetY
                    });
                }
            } catch (err) {
                // intersect fails silently if no splat under cursor
            }

            e.preventDefault();
            e.stopPropagation();
        };

        // Fire update every frame so GEA can reproject screen positions
        events.on('postrender', () => {
            if (active) events.fire('annotation.update');
        });

        this.activate = () => {
            active = true;
            canvasContainer.dom.addEventListener('pointerdown', pointerdown);
            canvasContainer.dom.addEventListener('pointermove', pointermove);
            canvasContainer.dom.addEventListener('pointerup', pointerup, true);
        };

        this.deactivate = () => {
            active = false;
            canvasContainer.dom.removeEventListener('pointerdown', pointerdown);
            canvasContainer.dom.removeEventListener('pointermove', pointermove);
            canvasContainer.dom.removeEventListener('pointerup', pointerup, true);
        };
    }
}

export { AnnotationTool };